/**
 * VendorStatusHistoryService
 * Service for managing vendor status history
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor status history CRUD operations with vendor-specific queries
 */
export class VendorStatusHistoryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorStatusHistoryService.DEFAULT_SERVICE_PATH,
            basePath: VendorStatusHistoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all status history for a specific vendor
     * @param vendorId - The vendor ID
     * @returns Array of vendor status history views
     */
    async getByVendor(vendorId) {
        const response = await this.getByVendorRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get all status history for a specific vendor with full response
     * @param vendorId - The vendor ID
     * @returns ResponseData with array of vendor status history views
     */
    getByVendorRaw(vendorId) {
        const url = this.buildUrl(`vendor/${vendorId}`);
        return this.http.get(url);
    }
    // ==================== MODEL VIEW QUERIES ====================
    /**
     * Get all vendor status history as model views
     * @returns Array of vendor status history model views
     */
    async getViews() {
        const response = await this.getViewsRaw();
        return response.data ?? [];
    }
    /**
     * Get all vendor status history as model views with full response
     * @returns ResponseData with array of vendor status history model views
     */
    getViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    /**
     * Get vendor status history model view by ID
     * @param id - Status history ID
     * @returns The vendor status history model view
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`VendorStatusHistory view not found: id=${id}`);
        }
        return response.data;
    }
    /**
     * Get vendor status history model view by ID with full response
     * @param id - Status history ID
     * @returns ResponseData with vendor status history model view
     */
    getViewRaw(id) {
        const url = this.buildUrl(`${id}/view`);
        return this.http.get(url);
    }
    /**
     * Get all status history model views for a specific vendor
     * @param vendorId - Vendor ID
     * @returns Array of vendor status history model views
     */
    async getViewsByVendor(vendorId) {
        const response = await this.getViewsByVendorRaw(vendorId);
        return response.data ?? [];
    }
    /**
     * Get all status history model views for a specific vendor with full response
     * @param vendorId - Vendor ID
     * @returns ResponseData with array of vendor status history model views
     */
    getViewsByVendorRaw(vendorId) {
        const url = this.buildUrl(`vendor/${vendorId}/views`);
        return this.http.get(url);
    }
}
VendorStatusHistoryService.DEFAULT_SERVICE_PATH = 'vendors';
VendorStatusHistoryService.BASE_PATH = 'api/vendor-status-history';
//# sourceMappingURL=VendorStatusHistoryService.js.map